import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const {
    space05,
    space1,
    space2,
    borderRadius3,
    borderWidth2,
    colorBorderInput,
    colorIconDisabled,
    colorText,
    colorTextMedium,
    colorTextMediumLight,
  } = theme();

  return StyleSheet.create({
    brand: {
      color: colorTextMedium,
    },
    brandUnavailable: {
      color: colorTextMediumLight,
    },
    buttonDisabled: {
      opacity: 0.5,
    },
    disabledIcon: {
      color: colorIconDisabled,
    },
    labelWrapper: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      flexGrow: 1,
      justifyContent: "flex-start",
      marginVertical: `auto`,
    },
    price: {
      color: colorText,
    },
    priceStrikethrough: {
      color: colorTextMedium,
      marginLeft: 8,
      textDecorationLine: "line-through",
    },
    priceStrikethroughUnavailable: {
      color: colorTextMediumLight,
      marginLeft: 8,
      textDecorationLine: "line-through",
    },
    priceUnavailable: {
      color: colorTextMedium,
    },
    priceWrapper: {
      display: "flex",
      flexDirection: "row",
    },
    skeletonText: {
      marginBottom: space05,
    },
    title: {
      color: colorText,
    },
    titleUnavailable: {
      color: colorTextMedium,
    },
    unavailableImage: {
      opacity: 0.26,
    },
    variant: {
      color: colorTextMedium,
    },
    variantUnavailable: {
      color: colorTextMediumLight,
    },
    wishlistItem: {
      display: "flex",
      flexDirection: "row",
    },
    wishlistItemBody: {
      display: "flex",
      flexDirection: "row",
      flex: 1,
      justifyContent: "space-between",
    },
    wishlistItemButton: {
      padding: 0,
    },
    wishlistItemButtons: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    wishlistItemImage: {
      borderColor: colorBorderInput,
      borderRadius: borderRadius3,
      borderWidth: borderWidth2,
      height: 132,
      width: 104,
    },
    wishlistItemInfo: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-between",
      paddingBottom: space1,
      paddingLeft: space2,
    },
  });
};

export { style };
